/**
 * Small typed event channel: "a record of this type was just created somewhere else" (e.g. via the "Neu" menu of the app bar).
 * Open overview pages subscribe and reload their list. Based on window CustomEvents, so it needs no store or component reference.
 */
export type CreatedEntityType = 'institution' | 'student' | 'employee' | 'applicant' | 'training' | 'acquisitionList';

export type EntityCreatedDetail = {
    type: CreatedEntityType;
    id?: string;
};

const EVENT_NAME = 'vanilla:entity-created';

export const emitEntityCreated = (type: CreatedEntityType, id?: unknown): void => {
    const detail: EntityCreatedDetail = {type, id: id ? String(id) : undefined};
    window.dispatchEvent(new CustomEvent<EntityCreatedDetail>(EVENT_NAME, {detail}));
};

/**
 * Calls the handler whenever a record of the given type was created.
 * @returns the cleanup function, call it in beforeDestroy
 */
export const onEntityCreated = (type: CreatedEntityType, handler: (detail: EntityCreatedDetail) => void): () => void => {
    const listener = (event: Event) => {
        const detail = (event as CustomEvent<EntityCreatedDetail>).detail;
        if (detail && detail.type === type) {
            handler(detail);
        }
    };
    window.addEventListener(EVENT_NAME, listener);
    return () => window.removeEventListener(EVENT_NAME, listener);
};
